<p-avatar icon="pi pi-user" styleClass=" mx-2 cursor-pointer text-white px-2 space-x-2 bg-pink-500" shape="circle"></p-avatar>
